import React from 'react';

function SplitText({ text }) {
  const textLines = text.split('\n');
  const pattern = /<p(.*?)>(.*?)<\/p>/gi;


  const TextWithP = ({ text }) => {
    const paragraphs = parseText(text);

    return (
      <>
        {paragraphs.map((paragraph, index) => (
          <p key={index} {...paragraph.attributes}>
            {paragraph.content}
          </p>
        ))}
      </>
    );
  };

  const parseText = (text) => {
    const paragraphs = [];

    let match;
    let lastIndex = 0;

    while ((match = pattern.exec(text)) !== null) {
      const startIndex = match.index;
      const endIndex = pattern.lastIndex;

      // Ajoute le texte avant le tag <p>
      paragraphs.push({
        content: text.substring(lastIndex, startIndex),
        attributes: {},
      });

      // Ajoute le contenu du tag <p>
      paragraphs.push({
        content: match[2],
        attributes: parseAttributes(match[1]),
      });

      lastIndex = endIndex;
    }

    // Ajoute le reste du texte
    paragraphs.push({
      content: text.substring(lastIndex),
      attributes: {},
    });

    return paragraphs;
  };

  const parseAttributes = (attributesString) => {
    const attributes = {};
    if (attributesString) {
      const attributeList = attributesString.split(/\s+/);
      attributeList.forEach((attr) => {
        const [name, value] = attr.split('=');
        if (name && value) {
          attributes[name] = value.replace(/["']/g, '');
        }
      });
    }
    return attributes;
  };

  return (
    <div>
      {textLines.map((line, index) => {
        return (
          <TextWithP key={index} text={line} />
        )
      })}
    </div>
  );
}

export default SplitText;
